module.exports = __webpack_public_path__ + "img/logomarca.0a025884.png";